import React from 'react'
import FreeRideStepper from '../../Component/FreeRideStepper/FreeRideStepper'
import DriveWithUsStepper from '../../Component/DriveWithUsStepper/DriveWithUsStepper'
import { useLocation } from 'react-router-dom'
import PartnerWithUs from '../../Component/PartnerWithUsStepper/PartnerWithUsStepper'
const Form = () => {
  const {pathname} = useLocation()
  return (
    <div>
      {pathname.includes("get-free-ride")?
        <FreeRideStepper />
      :
      pathname.includes("drive-with-us")?
      <DriveWithUsStepper />
      :
      pathname.includes("partner-with-us")?
      <PartnerWithUs />
      :null}
    </div>
  )
}

export default Form